import { useEffect } from 'react';
import { useRouter } from 'next/router';

import Seo from '@/components/seo/seo';
import { getLayoutWithFooter } from '@/components/layouts/layout-with-footer';
import DownloadAppView from '@/components/download-app/download-app-view';
import { isNativeApp } from '@/lib/utils/native-communication';
import { NextPageWithLayout } from '@/types';

export { getStaticProps } from '@/framework/general.ssr';

const DownloadAppPage: NextPageWithLayout = () => {
  const router = useRouter();

  useEffect(() => {
    if (isNativeApp()) {
      void router.replace('/');
    }
  }, [router]);

  if (isNativeApp()) {
    return null;
  }

  return (
    <>
      <Seo
        title="Baixe o app Qualidoc"
        description="Baixe o aplicativo Qualidoc na App Store ou no Google Play e peça medicamentos pelo celular."
        url="baixe-o-app"
      />
      <DownloadAppView />
    </>
  );
};

DownloadAppPage.getLayout = getLayoutWithFooter;

export default DownloadAppPage;
